import React, { useEffect, useState } from "react";
import { getManufacturers, deleteManufacturers } from "../../../Utility/Api";
import { toast } from "react-toastify";
import "../../../Utility/pagination.css";
import { EditManufacturers } from "./form";
import { Deletemodel, Pagination } from "../../Common/Functions";
import { isReadonlyRoute, NaviGate } from "../../../Utility/function";
import { useLocation } from "react-router-dom";

const Manufacturers_list = () => {
  const { pathname } = useLocation();
  const readonly = isReadonlyRoute(pathname);
  const [manufacturers, setManufacturers] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [deleteModal, showdeleteModal] = useState(false);
  const [DeleteID, setDeleteID] = useState("");
  const [showEditModal, setShowEditModal] = useState(false);
  const [selectedManufacturers, setSelectedManufacturers] = useState(null);
  const [addoredit, setaddoredit] = useState();
  const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const rolesPerPage = 10; // Number of roles per page

  useEffect(() => {
    fetchManufacturers();
  }, []);

  const Handledeletemodule = (ID) => {
    showdeleteModal(true);
    setDeleteID(ID);
  };

  const fetchManufacturers = async (page = 1, text = "") => {
    try {
      const response = await getManufacturers(page, text);
      if (response?.data && response?.data?.data) {
        setManufacturers(response?.data?.data);
        setTotalPages(response?.data.pagination?.total_pages); // Update total pages for pagination
      }
    } catch (error) {
      console.error("Error fetching Customers data:", error);
    }
  };

  const openAddModal = () => {
    setaddoredit(true);
    setShowEditModal(!showEditModal);
  };
  const openEditModal = (man) => {
    setSelectedManufacturers(man);
    setaddoredit(false);
    setShowEditModal(!showEditModal);
  };

  // Delete a category
  const handleDelete = async () => {
    try {
      await deleteManufacturers(DeleteID);
      showdeleteModal(false);
      toast.error("Manufacturers deleted successfully");
      fetchManufacturers(currentPage);
    } catch (error) {
      console.error("Error deleting Manufacturers:", error);
      // toast.error("Error deleting Manufacturers");
    }
  };

  // Pagination logic
  const handlePageChange = (pageNumber) => {
    if (pageNumber < 1 || pageNumber > totalPages) return;
    setCurrentPage(pageNumber);
    fetchManufacturers(pageNumber);
  };

  const handleSearch = async (text) => {
    fetchManufacturers(1, text);
  }

  return (
    <div className="page-wrappers">
      <div className="page-content">
        <NaviGate />
        <div className="mb-0 d-flex justify-content-between align-items-center">
          <h6 className="mb-0 text-uppercase">Manufacturers List</h6>
          {!readonly && <button
            type="button"
            onClick={() => openAddModal()}
            className="btn btn-primary mb-0 text-normal rounded-1"
          >
            Add Manufacturers
          </button>}
        </div>
        <hr className='mt-1' />


        <div className="card">
          <div className="card-body">
            <div className="col-12 col-md-6 col-lg-4 mb-3 mb-md-2">
              <div className="d-flex position-relative" style={{ width: "100%" }}>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  placeholder="Search..."
                  onChange={(e) => handleSearch(e.target.value)}
                />
                <img
                  src="/assets/images/icons/search.png"
                  alt="Search Icon"
                  style={{
                    position: "absolute",
                    right: "12px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    height: "18px",
                    pointerEvents: "none",
                  }}
                />
              </div>
            </div>
            <div className="table-responsive">
              <table
                id="example"
                className="table table-sm  table-striped table-bordered"
                style={{ width: "100%", fontFamily: "poppins" }}
              >
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Name</th>
                    <th>Country</th>
                    {!readonly && <th>Action</th>}
                  </tr>
                </thead>
                <tbody>
                  {manufacturers.map((man, index) => (
                    <tr key={man.manufacturer_id}>
                      <td>{(currentPage - 1) * rolesPerPage + index + 1}</td>
                      <td>{man.name}</td>
                      <td>{man.country}</td>
                      {!readonly && <td>
                        <img src='/assets/images/icons/edit.png' onClick={() => openEditModal(man)} height={"16px"} />
                        &nbsp;&nbsp;&nbsp;
                        <img src='/assets/images/icons/delete.png' className="mx" onClick={() => Handledeletemodule(man.manufacturer_id)} height={"16px"} />
                      </td>}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* Pagination controls */}
              <Pagination
                currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={handlePageChange}
              />

            </div>
          </div>
        </div>
      </div>
      {deleteModal && (
        <Deletemodel
          setShowModal={showdeleteModal}
          handleDelete={handleDelete}
        />
      )}

      <EditManufacturers
        showModal={showEditModal}
        setShowModal={() => openEditModal()}
        fetchManufacturers={() => fetchManufacturers()}
        selectedManufacturers={selectedManufacturers}
        AddorEdit={addoredit}
      />
    </div>
  );
};

export default Manufacturers_list;
